import Vue from "vue";

const ENDPOINTS = {
  assign: "courts/assign"
};

export class Courts {
  constructor(config) {
    this.api_url = config.api_url;
    this.stage = config.stage;
  }

  get_endpoint(name) {
    return `${this.api_url}/${this.stage}/${ENDPOINTS[name]}/`;
  }

  async get_bankruptcy_court_from_backend(province, postal_code) {
    let endpoint = this.get_endpoint("assign");
    try {
      let post_data = {
        method: "POST",
        url: endpoint,
        data: {
          zip_code: postal_code
        }
      };

      let response = await Vue.axios(post_data);
      if (response.status == 200) {
        return response.data.item;
      } else {
        return null;
      }
    } catch (err) {
      console.error(err);
    }
    return null;
  }
}
